export default "__VITE_ASSET__DCQxyQ40__"